import styled from "styled-components";
import SVG from "react-inlinesvg";

export const ItemButton = styled.a`
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    width: 32%;
    height: 32%; 
    background: ${(props) => (props.$select ? '#014642' : 'transparent')};
    border: none;
    border-radius: 5px;
    cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
    filter: ${(props) => (props.$active ? 'grayscale(0)' : 'grayscale(100)')};
    transition: 0.8s;
    color: ${(props) => (props.$active ? '#F2F2F2' : '#A3A3A3')};
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-decoration: none;
    &:hover {
        background: ${(props) => (props.disabled ? 'transparent' : '#3E78AA')};
    }
`;

export const MenuIcon = styled(SVG)`
    width: 40px;
    height: 40px;
    align-self: center;
    & path {
        fill: ${({ fill }) => fill};
    }
`;